.welcome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-12);
  padding: var(--space-24) var(--space-20) var(--space-16);
}

.message {
  margin: var(--space-4) 0 var(--space-4);
  font-size: 17px;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.005em;
  text-wrap: pretty;
}

.suggestions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-8);
  width: 100%;
}

.chip {
  max-width: 100%;
  min-height: 40px;
  padding: var(--space-8) var(--space-16);
  border: 1px solid var(--w-border-strong);
  border-radius: 999px;
  background: var(--w-bg);
  color: var(--w-text);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
  text-align: left;
  cursor: pointer;
  transition: transform 120ms var(--ease-out), background-color 120ms ease, border-color 120ms ease, opacity 200ms ease;
  @starting-style {
    opacity: 0;
  }
  transition-delay: 0ms, 0ms, 0ms, calc(var(--i, 0) * 40ms);
}

.chip:active {
  transform: scale(0.97);
  background: var(--w-press);
}

.chip:disabled {
  cursor: default;
  opacity: 0.5;
}

@media (hover: hover) and (pointer: fine) {
  .chip:hover:not(:disabled) {
    border-color: var(--w-accent-text);
    background: var(--w-hover);
  }
}
